module.exports = __webpack_public_path__ + "img/EventAvailableOutlined.d6fe7f4d.svg";